export enum SkuStatus {
    PURCHASEABLE = "purchasable",
    OWNED = "owned",
    CLAIMING = "claiming"
}

export enum SkuType {
    SILVER_PACKAGE = "silver-package",
    AVATAR = "avatar"
}

export interface Sku {
    content: string,
    name: string,
    price: number, 
    status: SkuStatus,
    type: SkuType,
    _id: string,
    is_visible: boolean,
    //added fields
    parsedContent?: Record<string,any>,
    avatarImg?: any,
    coverImg?: any,
    tagImg?: any,
    detailImg?: any,
    headingColor?: string,
    descriptionColor?: string,
    description?: string
}